import { Account } from '@eagle/core-data-types';
import { LDFlagSet } from 'launchdarkly-js-sdk-common';
import { get } from 'lodash';
import { DomainCustomConfig } from '../../auth';
import { SideMenuItemDefinition, SideMenuToDefinition } from './side-menu.types';

export const sideMenuTransitionStyles = {
  transition: '250ms all ease',
};

export const isSideMenuItemVisible = (menuItem: SideMenuItemDefinition, account: Account, flags: LDFlagSet, hasAuthorization: (roles: readonly string[]) => boolean, config: Partial<DomainCustomConfig>): boolean => {
  if (!menuItem.visibility) return true;
  return menuItem.visibility.every((visibilityDefinition) => {
    switch (visibilityDefinition.type) {
      case 'feature-flag':
        return flags[visibilityDefinition.flag] === true;
      case 'role-function':
        return hasAuthorization(visibilityDefinition.roleFunctions);
      case 'domain-config':
        return Boolean(get(config, visibilityDefinition.path));
      case 'account-field':
        return Boolean(get(account, visibilityDefinition.path));
    }
  });
};

export const resolveSideMenuToDefinition = (to: SideMenuToDefinition, customRoutes: Record<string, string>, config: Partial<DomainCustomConfig>): string => {
  if (typeof to === 'string') {
    return to;
  }

  return to.map((toPart) => {
    if (typeof toPart === 'string') {
      return toPart;
    }
    if (toPart.type === 'custom-route') {
      return customRoutes[toPart.name];
    }
    if (toPart.type === 'domain-config') {
      return get(config, toPart.path) as string;
    }
  }).join('');
};
